/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Row, Col, Image } from 'react-bootstrap';
import * as S from './styles';
import { AppCardTitleImageStyle } from './styles';

export interface IAppCardList {
  name: string;
  value: string;
}

const background = require('./assets/green-pattern.jpeg');

export interface IAppCardWidgetProps {
  appCardId: string;
  appCardImage?: string;
  appCardTitle?: string;
  appCardDescription?: string;
  appCardList?: IAppCardList[];
  onAppCardClick?(): void;
  hoverColor: string;
}
const getFirstLetterOfEachWord = (text: string) =>
  text?.match(/\b\w/g)?.join('');

export const AppCardWidget = ({
  appCardId,
  appCardTitle,
  appCardImage,
  appCardDescription,
  appCardList,
  hoverColor,
  onAppCardClick,
}: IAppCardWidgetProps) => {
  const _renderImageIf = () => {
    if (appCardImage) {
      return (
        <Image
          src={appCardImage}
          className="rounded-1"
          width={100}
          height={'auto'}
          style={{ objectFit: 'contain', marginTop: 0 }}
        />
      );
    }
    if (appCardTitle) {
      return (
        <div
          className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary"
          style={S.AppCardTitleImageStyle}
        >
          <span>{getFirstLetterOfEachWord(appCardTitle)}</span>
        </div>
      );
    }
    return null;
  };
  return (
    <S.AppCard
      border="0"
      onClick={onAppCardClick?.bind(null, appCardId)}
      hoverColor={hoverColor}
    >
      <article
        className={'article'}
        style={{
          // backgroundImage: `url(${background})`,
          borderRadius: '10px',
        }}
      >
        <Card.Body>
          <Row>
            <Col xs={4} className="align-self-start">
              {_renderImageIf()}
            </Col>
            <Col xs={8}>
              {appCardTitle && (
                <h5 className="mb-0 mt-0" style={S.HeadingStyle}>
                  {appCardTitle}
                </h5>
              )}
              {appCardDescription && (
                <S.DescriptionStyle style={{ color: '#0b0b0b' }}>
                  {appCardDescription}
                </S.DescriptionStyle>
              )}
              <div
                className="p-2 mt-2 d-flex justify-content-between rounded"
                style={S.SectionContainer}
              >
                {appCardList?.map((list, index) => (
                  <div
                    key={`app-card-kv-${index}`}
                    className="d-flex flex-column"
                    style={{ backgroundColor: 'transparent' }}
                  >
                    <span style={S.SectionNameStyle}>{list?.name}</span>
                    {/*<span className="fw-bold">{list?.value}</span>*/}
                    <h3 className="fs-4 fw-extrabold mb-1">{list?.value}</h3>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </article>
    </S.AppCard>
  );
};

AppCardWidget.defaultProps = {};
